let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kQxrB")).then(() => parcelRequire('hfWkk'));